import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

interface Product {
  allowedRequestTypes: null | string;
  description: null | string;
  id: number;
  monthlyPrice: null | number;
  stripeMonthlyProductId: null | string;
  title: string;
}

export function useProducts() {
  return useQuery<Product[]>({
    queryFn: async () =>
      await apiClient.url("/products").get().json<Product[]>(),
    queryKey: ["products"],
    staleTime: 5 * 60 * 1000,
  });
}
